
<app-connectwise-handler [debug]="false" (eventHandler)="onConnectWiseEvent($event)"></app-connectwise-handler>
<div class="no-title-layout" [ngStyle]="themeManager.getUnderlayStyle(true)" style="height:100%">
    <!-- RS:{{requestedState}}
  S:{{state}}
  <button (click)="updateState()">Update State</button> -->

  <ng-container *ngIf="state=='LOADING'">
    <mat-toolbar class="secondary-toolbar mat-elevation-z1"></mat-toolbar>
    <section class="main-content">
      <div class="dashboard-tile" style="width:300px; height: auto; margin:auto;">
        <app-grid-spinner #spinner></app-grid-spinner>
        <div class="tile-header">
          <div class="tile-header-title">
            Loading
          </div>
        </div>
        <div class="tile-content">
          <div style="height:300px;">
            <img mat-card-image class="tile-logo" src="{{themeManager.getStackedLogo()}}" >
            <div style="padding:50px 20px 0 20px; text-align:center;">Accessing the Identify Platform</div>
            <div style="padding:5px 20px 0 20px; text-align:center;"><mat-progress-bar mode="indeterminate"></mat-progress-bar></div>
          </div>
        </div>
      </div>
    </section>
  </ng-container>

  <cw-ci-msp-dashboard *ngIf="state=='MSPDASHBOARD'"></cw-ci-msp-dashboard>
  <cw-ci-industry-comparison-dashboard *ngIf="state=='CLIENTCOMPARISONS'"></cw-ci-industry-comparison-dashboard>

  <ng-container *ngIf="state=='ROUTING'">
    <router-outlet></router-outlet>
  </ng-container>

  <ng-container *ngIf="state=='ACCOUNTUNAVAILABLE'">
    <mat-toolbar class="secondary-toolbar mat-elevation-z1">
    </mat-toolbar>
    
    <section class="main-content">
      <app-expired [dialogReason]="unavailableReason" [dialogMessage]="dialogMessage"></app-expired>
    </section>
  </ng-container>

  <ng-container *ngIf="state=='ERRORSTATE'">
      <cw-dialog [title]='dialogTitle' style="height:470px;">
        <span>{{dialogMessage}}</span>
      </cw-dialog>
    </ng-container>
</div>
